/**
 * @module CommonComponents
 */

import { Paper, Typography } from '@mui/material'
import { LineChart } from '@mui/x-charts/LineChart'

/**
 * Componente reutilizable de gráfico de líneas basado en MUI X Charts
 * @param {CustomLineChartProps} props
 */
const CustomLineChart = ({
  title,
  labels = [],
  series = [],
  height = 350,
  xAxisLabel,
  yAxisLabel,
  showGrid = true,
  sx = {},
}) => {
  return (
    <Paper sx={{ p: 3, ...sx }}>
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
          {title}
        </Typography>
      )}
      <LineChart
        xAxis={[{ scaleType: 'point', data: labels, label: xAxisLabel }]}
        yAxis={[{ label: yAxisLabel }]}
        series={series}
        height={height}
        grid={showGrid ? { vertical: true, horizontal: true } : undefined}
      />
    </Paper>
  )
}

export default CustomLineChart

/**
 * @typedef CustomLineChartSeries
 * @prop {Array<number>} data - Valores de la serie
 * @prop {string} label - Nombre de la serie (aparece en leyenda)
 * @prop {string} [color] - Color de la línea
 * @prop {boolean} [showMark=true] - Mostrar marcadores en cada punto
 */

/**
 * @typedef CustomLineChartProps
 * @prop {string} [title] - Título del gráfico
 * @prop {Array<string>} labels - Etiquetas del eje X
 * @prop {Array<CustomLineChartSeries>} series - Series de datos
 * @prop {number} [height=350] - Altura del gráfico en píxeles
 * @prop {string} [xAxisLabel] - Etiqueta del eje X
 * @prop {string} [yAxisLabel] - Etiqueta del eje Y
 * @prop {boolean} [showGrid=true] - Mostrar rejilla
 * @prop {import('@mui/system').SxProps} [sx] - Estilos adicionales del contenedor
 */
